import classnames from 'classnames'
import Parse from 'html-react-parser'

import ButtonPrimary from '../../Buttons/ButtonPrimary'

import * as S from './styles'

import IconSuccess from '../../../../assets/icons/modal-alert/sucesso.svg'
import IconError from '../../../../assets/icons/modal-alert/erro.svg'
import IconWarning from '../../../../assets/icons/modal-alert/aviso.svg'

export default function ModalAlert(props) {
  let icon = IconSuccess
  if (props.type === 'error') {
    icon = IconError
  }
  if (props.type === 'warning') {
    icon = IconWarning
  }
  return (
    <S.Modal className={props.active ? 'active' : ''} data-cy={props.dataCy}>
      <S.Content>
        <S.FlexContainerRelative>
          <img
            className={classnames('iconAlert', props.active ? 'animationImgToFront' : '')}
            src={icon}
            alt=''
          />
        </S.FlexContainerRelative>

        <S.Title>{Parse(props.title)}</S.Title>

        <S.Description>{props.description}</S.Description>

        <S.FlexContainer>
          {props.onClick &&
            <ButtonPrimary
              text={props.textButton}
              size='lg'
              upperCase
              bold
              onClick={props.onClick}
            />}
        </S.FlexContainer>
      </S.Content>
    </S.Modal>
  )
}
